// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

type Props = {
  description?: string;
  htmlTitle?: string;
  title: string;
  siteName: string;
};

const defaultProps = {
  htmlTitle: undefined,
  description: undefined,
};

const CustomHelmet = ({ description, htmlTitle, title, siteName }: Props) => (
  <Helmet
    titleTemplate={htmlTitle ? '%s' : `%s | ${siteName}`}
    title={htmlTitle || title}
  >
    {description && <meta name="description" content={description} />}
  </Helmet>
);

CustomHelmet.defaultProps = defaultProps;

const mapStateToProps = state => ({
  siteName: state.settings.siteName,
});

export default connect(mapStateToProps)(CustomHelmet);
